export const useCartCounterFetch = (url, err, cb) => {
  const controller = new AbortController();
  const { signal } = controller;
  fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      Accept: 'application/json;q=0.9;v=1',
      'Content-Type': 'application/json;q=0.9;v=1',
    },
    body: JSON.stringify({ includeCartItemCount: true }),
    signal,
  }).then((res) => {
    if (!res.ok) {
      return;
    }
    switch (res.status) {
      case 401:
        cb(0);
        return;
      case 204:
        cb(0);
        return;
      case 200:
        try {
          res.json()
            .then((data) => {
              const { cartItemCount } = data;
              cb(cartItemCount);
            })
            .catch(err);
        } catch (e) {
          err(e);
        }
        return;
      default:
        err(new Error('Bad response'));
    }
  })
    .catch((e) => {
      if (e.name !== 'AbortError') {
        err(e);
      }
    });
  return () => controller.abort();
};

export default useCartCounterFetch;